export default __webpack_public_path__ + "static/media/f07c25ed-2d61-4e44-99ab-a0bc3ec67662.7f4fe881.ttf";